import { api } from "@/services";

type CorporateLocalityData = {
  zip: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  number: string;
  details: string;
  SetIsLoading?: any;
};

type CorporateLocalityRequestByZipcode = {
  zip: string;
};

type CorporateLocalityRequestByAddress = {
  City: string;
  State: string;
  District: string;
  Street: string;
};

type CorporateLocalityResponse = {
  total: string;
  result: [
    {
      id: string;
      state: string;
      city: string;
      district: string;
      street: string;
      zip: string;
      complement: string;
      name: string;
      CityCode: string;
      coordinates: {
        type: string;
        coordinates: number[];
      };
    }
  ];
};

type CorporateLocalityReturn = {
  Error: boolean;
  ErrorMessage: string;
  Refer: string;
  Zipcode: string;
  State: string;
  City: string;
  District: string;
  Street: string;
  Number: string;
  Complement: string;
};

async function useCorporateLocality({
  zip,
  state,
  city,
  neighborhood,
  street,
  number,
  details,
  SetIsLoading
}: CorporateLocalityData): Promise<CorporateLocalityReturn> {
  let Response = (<CorporateLocalityReturn>{}) as CorporateLocalityReturn;
  //   SetIsLoading(true);
  console.log("entrou aq");

  const Controller = new AbortController();

  const ConsultByAllData = async () => {
    try {
      SetIsLoading(true);
      const resp: { data: CorporateLocalityResponse } = await api.get(`/Locality/${zip}`, {
        signal: Controller.signal
      });
      if (resp.data.total === "0") {
        throw new Error("Não foi possível encontrar o endereço");
      } else {
        Response = {
          Error: false,
          ErrorMessage: "",
          Refer: "Encontrado pelo CEP",
          Zipcode: resp.data.result[0].zip,
          State: resp.data.result[0].state,
          City: resp.data.result[0].city,
          District: resp.data.result[0].district,
          Street: resp.data.result[0].street,
          Number: number,
          Complement: details
        };
      }
    } catch (error) {
      try {
        const resp: { data: CorporateLocalityResponse } = await api.get(`/Locality`, {
          signal: Controller.signal,
          params: {
            City: city,
            State: state,
            District: neighborhood,
            Street: street
          }
        });
        if (resp.data.total === "0") {
          throw new Error("Não foi possível encontrar o CEP pelo endereço");
        } else {
          Response = {
            Error: false,
            ErrorMessage: "",
            Refer: "Encontrado pelo endereço",
            Zipcode: resp.data.result[0].zip,
            State: resp.data.result[0].state,
            City: resp.data.result[0].city,
            District: resp.data.result[0].district,
            Street: resp.data.result[0].street,
            Number: number,
            Complement: details
          };
        }
      } catch (error) {
        Response = {
          Error: true,
          ErrorMessage: error.message,
          Refer: "Não foi possível encontrar pelo CEP nem pelo endereço",
          Zipcode: zip,
          State: state,
          City: city,
          District: neighborhood,
          Street: street,
          Number: number,
          Complement: details
        };
      }
    }
  };

  await ConsultByAllData();

  Controller.abort();
  console.log("saiu aq");

  //   SetIsLoading(false);
  return Response;
}

export { useCorporateLocality };
